/**
 * Generated runtime TestId mirror for frontend/src/pages/OutboundConnectors.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const OutboundConnectorsTestIds = {
  colLastUpdated: "col-last-updated",
  colStatus: "col-status",
  colSystem: "col-system",
  colType: "col-type",
  connectorTypeSelect: "connector-type-select",
  connectorsSkeleton: "connectors-skeleton",
  connectorsTable: "connectors-table",
  createConnectorButton: "create-connector-button",
  outboundConnectorsList: "outbound-connectors-list",
  connectorName: (connector_id: string) => `connector-name-${connector_id}`,
  connectorNamePrefix: () => "connector-name-" as TestIdPrefix,
  connectorRow: (connector_id: string) => `connector-row-${connector_id}`,
  connectorRowPrefix: () => "connector-row-" as TestIdPrefix,
  connectorType: (connector_id: string) => `connector-type-${connector_id}`,
  connectorTypePrefix: () => "connector-type-" as TestIdPrefix
} as const;
